import * as React from 'react';
const PelleGrassaDellaSchienaIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{fill:${primaryColor ||
        '#282828'}}.prefix__cls-2{fill:none;stroke:${secondaryColor ||
        '#ffcf38'};stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M91.4 54.43a1.993 1.993 0 0 0-1.57 2.34c.41 2.09-1.46 4.69-3.28 5.44-2.49 1.03-4.68 2.38-6.8 3.69-2.39 1.48-4.64 2.87-7.23 3.78-5.82 2.04-9.9 4.39-12.25 9.81-3.82 8.81-3.29 19.42-3.13 21.65-.21 1.04-1.61 7.83-3.31 17a1.988 1.988 0 0 0 1.96 2.35c.96 0 1.78-.68 1.96-1.63 1.77-9.5 3.2-16.42 3.36-17.2.04-.19.05-.39.03-.58-.01-.11-.98-11.32 2.79-20.01 1.57-3.62 4.17-5.62 9.91-7.64 2.99-1.05 5.53-2.62 8-4.15 2.08-1.28 4.04-2.5 6.23-3.4 3.33-1.38 6.47-5.78 5.67-9.89a1.99 1.99 0 0 0-2.34-1.57Z"
      className="prefix__cls-1"
    />
    <path
      d="M76.54 102.98c-.32-1.02-.65-2.07-.94-3.1l-.14-.51c-.74-2.67-1.59-5.69-1.42-8.19.04-.53-.14-1.04-.49-1.44s-.83-.64-1.36-.68c-.52-.03-1.04.13-1.44.48s-.65.84-.68 1.37c-.22 3.18.72 6.55 1.55 9.53l.14.5c.31 1.1.65 2.2 1 3.29.49 1.54.94 3.03 1.3 4.52-.12.22-.2.46-.23.71-.11.96-.51 2.09-.9 3.23-.2.56-.4 1.15-.57 1.72-.42 1.42-1.38 3.71-1.96 4.71-.27.46-.34.99-.21 1.51s.46.95.92 1.22c.3.18.65.28 1.01.28.7 0 1.36-.38 1.72-.98.41-.7.88-1.71 1.31-2.73.18 3.38.18 6.38 0 9.3-.25 3.93-.57 8.1-1.54 12.14-.05.22-.12.47-.2.74-.27.94-.57 2.01-.51 3.12a1.99 1.99 0 0 0 1.99 1.89h.1c.53-.03 1.02-.26 1.38-.66.36-.39.54-.9.51-1.44-.02-.45.19-1.22.37-1.84.08-.29.17-.6.24-.9 1.04-4.35 1.38-8.72 1.64-12.82.31-4.96.14-10.13-.57-16.77-.31-2.87-1.16-5.57-2-8.22ZM146.17 118.14c-1.71-9.17-3.1-15.96-3.31-17 .16-2.23.7-12.84-3.13-21.65-2.35-5.42-6.43-7.77-12.25-9.81-2.58-.9-4.83-2.3-7.23-3.78-2.12-1.31-4.31-2.66-6.8-3.69-1.82-.75-3.69-3.35-3.28-5.44.21-1.08-.49-2.13-1.57-2.34-1.07-.21-2.12.49-2.34 1.57-.81 4.11 2.34 8.51 5.67 9.89 2.19.91 4.15 2.12 6.23 3.4 2.46 1.52 5.01 3.1 8 4.15 5.75 2.01 8.34 4.01 9.91 7.64 3.77 8.69 2.8 19.9 2.79 20.01-.02.2 0 .39.04.6.16.76 1.59 7.69 3.35 17.18.18.94 1 1.63 1.96 1.63.12 0 .24-.01.37-.03 1.08-.2 1.79-1.24 1.59-2.32Z"
      className="prefix__cls-1"
    />
    <circle cx={117.5} cy={127.9} r={17.94} className="prefix__cls-2" />
    <path
      d="M117.5 118.81s6.31 5.16 6.31 11.88a6.31 6.31 0 1 1-12.62 0c0-6.72 6.31-11.88 6.31-11.88"
      className="prefix__cls-2"
    />
    <path d="M119.09 130.54s-.21 1.09-1.05 1.34" className="prefix__cls-2" />
    <path
      d="m128.38 100.44-.14.5c-.18.65-.38 1.31-.58 1.95a1.989 1.989 0 0 1-3.9-.57c0-.25.05-.49.13-.71.18-.58.35-1.16.51-1.73l.14-.51c.74-2.67 1.59-5.69 1.42-8.19-.04-.53.13-1.04.48-1.44s.84-.64 1.37-.68 1.04.14 1.44.49.64.83.68 1.36c.22 3.18-.72 6.55-1.55 9.53"
      className="prefix__cls-1"
    />
  </svg>
);
export default PelleGrassaDellaSchienaIcon;
